import { render, staticRenderFns } from "./TeacherDocPolicyForm.vue?vue&type=template&id=9d3d11b4&scoped=true"
import script from "./TeacherDocPolicyForm.vue?vue&type=script&lang=js"
export * from "./TeacherDocPolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3d11b4",
  null
  
)

export default component.exports